module.exports = __webpack_public_path__ + "static/media/mksu_logo.183d304c.png";